import { render, staticRenderFns } from "./InvoiceViewModal.vue?vue&type=template&id=3b950bfa&"
import script from "./InvoiceViewModal.vue?vue&type=script&lang=js&"
export * from "./InvoiceViewModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports